// メニューコード一覧

export const トップメニューコード = {
  トップ: "010010",
  パスワード変更: "010011",
} as const
export const 受注配車メニューコード = {
  配車入力: "020010",
  簡易受注配車入力: "020020",
  受注配車一覧: "020030",
  受注配車入力: "020031",
  配車表: "020032",
  受注配車パターン一覧: "020040",
  受注配車パターン登録: "020041",
  車番連絡表印刷: "020050",
  運送業務発注書印刷: "020060",
  分割受注配車一覧: "020071",
  分割受注配車入力: "020072",
} as const
export const 海コン受注配車メニューコード = {
  海コン_簡易受注配車入力: "030010",
  海コン_受注配車一覧: "030020",
  海コン_受注配車入力: "030021",
  海コン_配車表: "030022",
  海コン_受注パターン一覧: "030030",
  海コン_受注パターン登録: "030031",
} as const
export const 運行管理メニューコード = {
  点呼記録: "040010",
  点呼一覧: "040011",
  点呼結果一覧: "040012",
  運行管理者マスタ: "040020",
  運行指示書: "040030",
  デジタコデータ取込: "040040",
  デジタコ勤怠確認: "040041",
  ETCデータ取込: "040050",
  ETCデータ一覧: "040051",
  給油量データ取込: "040060",
  給油量一覧: "040061",
  乗務員別燃費一覧: "040070",
  燃料単価登録: "040080",
} as const
export const 請求_支払管理メニューコード = {
  請求処理: "050010",
  請求明細一覧: "050011",
  請求書表紙: "050012",
  支払処理: "050020",
  支払明細一覧: "050021",
  荷主報告書_山田産業: "050030",
  会計計上済修正データ作成: "050040",
  会計連携データ作成指示: "050050",
  運賃タリフ一覧: "050060",
  大陽乗務員売上入力: "050070",
  大陽乗務員手当マスタ登録: "050080",
  AGL鹿島ガラス高速料報告: "050090",
  コース距離タリフ一覧: "050100",
  コース距離タリフ登録: "050101",
  距離割増タリフ一覧: "050110",
  距離割増タリフ登録: "050111",
  AGL鹿島ガラス高速料タリフ: "050120",
} as const
export const 購買管理メニューコード = {
  備品在庫受入一覧: "060010",
  備品在庫受入登録: "060011",
  備品在庫受入履歴一覧: "060012",
  備品在庫払出一覧: "060020",
  備品在庫払出登録: "060021",
  備品在庫払出履歴一覧: "060022",
} as const
export const 乗務員管理メニューコード = {
  乗務員マスタ一覧: "070010",
  乗務員マスタ登録: "070020",
  乗務員所属マスタ: "070030",
  安全会議登録: "070040",
  安全会議実施一覧: "070041",
  適性診断対象一覧: "070050",
  適性診断実施一覧: "070051",
  適性診断実施登録: "070052",
  健康診断登録: "070060",
} as const
export const 車輌管理メニューコード = {
  車輌台数一覧: "080010",
  車輌マスタ: "080020",
  車輌マスタ登録: "080030",
  車輌所属マスタ: "080040",
  点検整備一覧: "080050",
  点検整備費入力: "080060",
} as const
export const 勤怠管理メニューコード = {
  出勤簿一覧: "090010",
  出勤簿: "090020",
  乗務員出勤簿一覧: "090030",
  乗務員出勤簿: "090031",
  乗務員出勤簿一覧_v2: "090050",
  乗務員出勤簿_v2: "090051",
  有給休暇管理: "090040",
} as const
/**
 * 予算_実績メニューコード
 * 業績会議 = 課題検討会議
 * お客様要望により名称変更
 */
export const 予算_実績メニューコード = {
  売上予算: "100010",
  売上予算_全社: "100011",
  業績会議_週報全社: "100020",
  業績会議_週報部所別: "100021",
  業績会議_荷主売上一覧: "100022",
  総合輸送会議_予算実績: "100030",
  総合輸送会議_粗利益一覧: "100031",
  総合輸送会議_荷主売上一覧: "100032",
  総合輸送会議_部所予算実績: "100033",
  荷主売上実績: "100040",
  車輌別運行収支一覧: "100050",
  乗務員売上一覧: "100060",
  付替実績一覧: "100070",
  車輌整備費用一覧: "100080",
  備品在庫受払表: "100090",
  車輌経費データ取込: "100100",
  車輌経費一覧: "100101",
} as const
export const 給与管理メニューコード = {
  乗務員運行月報: "130010",
  乗務員運行月報一覧: "130011",
  乗務員運行月報_v2: "130081",
  乗務員運行月報一覧_v2: "130082",
  乗務員給与マスタ: "130020",
  乗務員給与マスタ登録: "130021",
  乗務員給与一覧: "130030",
  乗務員給与調整入力: "130031",
  事務員就労時間一覧: "130040",
  事務員就労時間修正: "130041",
  乗務員固定費一覧: "130050",
  乗務員給与マスタ_v2: "130060",
  乗務員給与マスタ登録_v2: "130061",
  乗務員給与一覧_v2: "130070",
} as const
export const マスタ管理メニューコード = {
  社員マスタ: "110010",
  社員マスタ登録: "110011",
  社員所属変更一覧: "110140",
  部所マスタ: "110020",
  部所マスタ登録: "110021",
  荷主マスタ: "110030",
  荷主マスタ登録: "110031",
  荷主請求マスタ: "110040",
  荷主請求マスタ登録: "110041",
  積卸先マスタ: "110050",
  積卸先マスタ登録: "110051",
  品名マスタ: "110060",
  品名マスタ登録: "110061",
  支払先マスタ: "110070",
  支払先マスタ登録: "110071",
  食事手当マスタ: "110080",
  主要荷主マスタ: "110090",
  休日マスタ: "110100",
  区分マスタ: "110900",
  区分マスタ登録: "110901",
  傭車マスタ: "110110",
  傭車マスタ登録: "110111",
  所定時間マスタ: "110120",
  月次締め処理管理: "110800",
  お知らせ一覧: "110130",
  お知らせ登録: "110131",
} as const
export const Ayanas_Queryメニューコード = {
  Ayanas_Query: "900010",
  Ayanas_Query_条件管理_検索結果: "900020",
} as const

export const メニューコード = {
  トップ: トップメニューコード,
  受注配車: 受注配車メニューコード,
  海コン受注配車: 海コン受注配車メニューコード,
  運行管理: 運行管理メニューコード,
  請求_支払管理: 請求_支払管理メニューコード,
  購買管理: 購買管理メニューコード,
  乗務員管理: 乗務員管理メニューコード,
  車輌管理: 車輌管理メニューコード,
  勤怠管理: 勤怠管理メニューコード,
  予算_実績: 予算_実績メニューコード,
  給与管理: 給与管理メニューコード,
  マスタ管理: マスタ管理メニューコード,
  Ayanas_Query: Ayanas_Queryメニューコード,
} as const

const メニューコード一覧 = {
  ...トップメニューコード,
  ...受注配車メニューコード,
  ...海コン受注配車メニューコード,
  ...運行管理メニューコード,
  ...請求_支払管理メニューコード,
  ...購買管理メニューコード,
  ...乗務員管理メニューコード,
  ...車輌管理メニューコード,
  ...勤怠管理メニューコード,
  ...予算_実績メニューコード,
  ...給与管理メニューコード,
  ...マスタ管理メニューコード,
  ...Ayanas_Queryメニューコード,
} as const

export type Tメニュープロパティ名称 = keyof typeof メニューコード一覧
export type Tメニューコード =
  (typeof メニューコード一覧)[Tメニュープロパティ名称]
